export default __webpack_public_path__ + "static/media/gallery_2_300.489a1f46.webp";